export const GENERIC_MESSAGE_FOR_ALL_PRODUCTS = "GENERIC_MESSAGE_FOR_ALL_PRODUCTS"
export const GENERIC_BRAND_MESSAGE_FOR_ALL_PRODUCTS = "GENERIC_BRAND_MESSAGE_FOR_ALL_PRODUCTS"
export const VARIANT_MESSAGE = "VARIANT_MESSAGE"
export const BACKORDER_MESSAGE = "BACKORDER_MESSAGE"
export const BRAND_BACKORDER_MESSAGE = "BRAND_BACKORDER_MESSAGE"
export const TRIMMED_BRAND_NAME = "TRIMMED_BRAND_NAME"
export const SERVICE_HISTORY = "service history"
export const MILEAGE = "mileage"
export const KEEPERS = "keepers"
